import {
  FETCH_USER_SUBSCRIPTION_REQUEST,
  FETCH_USER_SUBSCRIPTION_SUCCESS,
  FETCH_USER_SUBSCRIPTION_FAILURE
} from "../types";

interface SubscriptionState {
  subscriptionActive: boolean;
  sub_loading: boolean;
}

const initialState: SubscriptionState = {
  subscriptionActive: false,
  sub_loading: false
};

export const subscriptionReducer = (state = initialState, action: any): SubscriptionState => {
  switch (action.type) {
    case FETCH_USER_SUBSCRIPTION_REQUEST:
      return { ...state, sub_loading: true };

    case FETCH_USER_SUBSCRIPTION_SUCCESS:
      return { subscriptionActive: action.payload, sub_loading: false };

    case FETCH_USER_SUBSCRIPTION_FAILURE:
      return { ...state, sub_loading: false };

    default:
      return state;
  }
};
